export const GET_DECIDED_RECHARGE_REQUESTS_REQUEST = "GET_DECIDED_RECHARGE_REQUESTS_REQUEST";
export const GET_DECIDED_RECHARGE_REQUESTS_SUCCESS = "GET_DECIDED_RECHARGE_REQUESTS_SUCCESS";
export const GET_DECIDED_RECHARGE_REQUESTS_FAILURE = "GET_DECIDED_RECHARGE_REQUESTS_FAILURE";
export const GET_DECIDED_RECHARGE_REQUESTS_RESET = "GET_DECIDED_RECHARGE_REQUESTS_RESET";
export const getDecidedRechargeRequestsRequest = (payload) => ({
    type: GET_DECIDED_RECHARGE_REQUESTS_REQUEST,
    payload,
});
export const getDecidedRechargeRequestsSuccess = (payload) => ({
    type: GET_DECIDED_RECHARGE_REQUESTS_SUCCESS,
    payload,
});
export const getDecidedRechargeRequestsFailure = (payload) => ({
    type: GET_DECIDED_RECHARGE_REQUESTS_FAILURE,
    payload,
});
export const getDecidedRechargeRequestsReset = () => ({
    type: GET_DECIDED_RECHARGE_REQUESTS_RESET,
});
